import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	Input,
	OnDestroy,
	OnInit,
} from '@angular/core';
import { CmmsTableService } from '@app/pages/cmms/services/cmms-table.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
	selector: 'au-classification-badge',
	templateUrl: 'au-classification-badge.component.html',
	styleUrls: ['au-classification-badge.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [MatTooltipModule],
})
export class AuClassificationBadgeComponent implements OnInit, OnDestroy {
	@Input() classifications: any[];
	@Input() filterBy: string;

	private destroy$ = new Subject<void>();
	filteredClassifications: any[];

	constructor(
		private cmmsTableService: CmmsTableService,
		private cdRef: ChangeDetectorRef
	) {}

	ngOnInit() {
		this.cmmsTableService.headerEventsStream
			.pipe(takeUntil(this.destroy$))
			.subscribe(headerEvents => {
				this.filterBy = headerEvents.classificationFiltration;
				this.filteredClassifications = this.classifications?.filter(
					classification => classification.type === headerEvents.classificationFiltration
				);
				this.cdRef.detectChanges();
			});
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
